"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKUtils = void 0;
__exportStar(require("./src/index"), exports);
__exportStar(require("./src/zod-schemas"), exports);
const generateRequestId = (params) => {
    const prefix = Math.random().toString(36).substring(2, 7);
    const encodedParams = Buffer.from(JSON.stringify({ ...params, prefix })).toString("base64");
    return `${prefix}-${encodedParams}`;
};
const decodeRequestId = (requestId) => {
    const [prefix, encodedParams] = requestId.split("-", 2);
    const params = JSON.parse(Buffer.from(encodedParams, "base64").toString("utf-8"));
    return {
        prefix,
        params,
    };
};
exports.SDKUtils = {
    generateRequestId,
    decodeRequestId,
};
/*
  </Utils>
*/
//# sourceMappingURL=index.js.map